const YOUTUBE_HOSTS = new Set(['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtu.be']);

export function extractYoutubeVideoIdFromUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  try {
    const parsed = new URL(url);
    if (!YOUTUBE_HOSTS.has(parsed.hostname)) return null;

    if (parsed.hostname === 'youtu.be') {
      return parsed.pathname.slice(1).split('/')[0] || null;
    }

    const vParam = parsed.searchParams.get('v');
    if (vParam) return vParam;

    const segments = parsed.pathname.split('/').filter(Boolean);
    const prefixIndex = segments.findIndex(
      (segment) => segment === 'embed' || segment === 'shorts' || segment === 'live',
    );
    if (prefixIndex >= 0 && segments[prefixIndex + 1]) return segments[prefixIndex + 1];

    return null;
  } catch {
    return null;
  }
}
